import React, { useState } from "react";
import { X } from "@phosphor-icons/react";

const REASONS = [
  "Too expensive",
  "Going with another tradesperson",
  "Not available when I need it",
  "Changed my mind / no longer needed",
  "Trader didn't respond to messages",
  "Other",
];

export default function DeclineReasonModal({ open, onClose, onConfirm, traderName, amount }) {
  const [reason, setReason] = useState("");
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);

  if (!open) return null;

  const submit = async () => {
    if (!reason) return;
    setBusy(true);
    try {
      await onConfirm({ reason, note: note.trim() || null });
      setReason(""); setNote("");
    } finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 p-4" onClick={onClose} data-testid="decline-modal">
      <div className="bg-white rounded-xl max-w-md w-full p-6 relative" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} className="absolute top-3 right-3 p-1 text-[var(--text-muted)] hover:text-[var(--brand-green)]" data-testid="decline-close-btn">
          <X size={20} />
        </button>
        <h3 className="font-display font-extrabold text-xl" style={{ color: "var(--brand-green)" }}>Decline quote</h3>
        <p className="text-sm text-[var(--text-muted)] mt-1">
          {traderName ? <>Declining <strong>{traderName}'s</strong> £{Number(amount).toFixed(2)} quote. </> : null}
          A quick reason helps trades improve future quotes.
        </p>

        <div className="mt-5 space-y-2" data-testid="decline-reasons-list">
          {REASONS.map((r) => (
            <label key={r} className={`flex items-center gap-3 p-3 rounded-md border cursor-pointer transition-colors ${
              reason === r ? "border-[var(--brand-orange)] bg-[rgba(226,109,41,0.06)]" : "border-[var(--border-stone)] hover:border-[var(--brand-green)]"
            }`} data-testid={`decline-reason-${r.replace(/\W+/g, "-").toLowerCase()}`}>
              <input
                type="radio"
                name="decline-reason"
                value={r}
                checked={reason === r}
                onChange={(e) => setReason(e.target.value)}
                className="accent-[var(--brand-orange)]"
              />
              <span className="text-sm">{r}</span>
            </label>
          ))}
        </div>

        <label className="block mt-4">
          <span className="text-xs font-semibold text-[var(--text-muted)]">Additional notes (optional)</span>
          <textarea
            data-testid="decline-note-input"
            rows={2}
            value={note}
            onChange={(e) => setNote(e.target.value)}
            placeholder="Anything you'd like the trader to know"
            className="w-full mt-1 px-3 py-2 rounded-md border border-[var(--border-stone)] bg-white focus:outline-none focus:ring-2 focus:ring-[var(--brand-orange)] resize-y text-sm"
          />
        </label>

        <div className="mt-5 flex gap-2 justify-end">
          <button onClick={onClose} className="btn-ghost" data-testid="decline-cancel-btn">Cancel</button>
          <button
            onClick={submit}
            disabled={!reason || busy}
            className="btn-primary disabled:opacity-50"
            data-testid="decline-confirm-btn"
          >
            {busy ? "Declining…" : "Confirm decline"}
          </button>
        </div>
      </div>
    </div>
  );
}
